import React from 'react';
import {AppSubtitle, AppWarningText, AppText} from '../../../../Presentation/components/ui/Typography';
import {Badge} from '../../../../Presentation/components/ui/Badge';
import {Role} from '../../models/role.model';
import {Shield, AlertCircle} from 'lucide-react';

interface RoleInfoProps {
  role: Role;
}

/**
 * Reusable component for displaying role information
 */
export const RoleInfo: React.FC<RoleInfoProps> = ({role}) => {
  return (
    <>
      {/* Role Info */}
      <div className="flex items-center space-x-4 space-x-reverse">
        <div className="flex items-center space-x-2 space-x-reverse">
          <Shield className="w-6 h-6 text-brand-600" />
          <AppSubtitle>{role.displayName || role.name}</AppSubtitle>
        </div>
        <Badge variant="secondary">
          {role.permissions?.length || 0} صلاحية
        </Badge>
      </div>

      {/* System Role Warning */}
      {role.isSystem && (
        <div className="bg-amber-50 border border-amber-200 rounded-lg p-4">
          <div className="flex items-start space-x-3 space-x-reverse">
            <AlertCircle className="w-5 h-5 text-amber-600 mt-0.5" />
            <div>
              <AppWarningText className="text-amber-800 font-medium">
                تحذير: دور نظام
              </AppWarningText>
              <AppText className="text-amber-700 mt-1">
                هذا دور نظام. تعديل الصلاحيات قد يؤثر على وظائف النظام الأساسية.
              </AppText>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
